"use client";
import React, { ReactNode } from "react";

interface EmailLinkProps {
    email: string;
    children?: ReactNode;
    className?: string;
    subject?: string;
    body?: string;
}

export const EmailLink: React.FC<EmailLinkProps> = ({ email, children, className = "", subject = "", body = "" }) => {
    const buildMailtoUrl = () => {
        let url = `mailto:${email}`;
        const params = [];

        if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
        if (body) params.push(`body=${encodeURIComponent(body)}`);

        if (params.length > 0) {
            url += `?${params.join("&")}`;
        }

        return url;
    };

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        const mailtoUrl = buildMailtoUrl();

        if (typeof window !== "undefined" && window.NativeBridge?.openUrlInBrowser) {
            window.NativeBridge.openUrlInBrowser(mailtoUrl);
        } else {
            window.location.href = mailtoUrl;
        }
    };

    const mailtoUrl = buildMailtoUrl();

    if (typeof window === "undefined" || !window.NativeBridge?.openUrlInBrowser) {
        return (
            <a href={mailtoUrl} className={className} target="_blank" rel="noopener noreferrer">
                {children || email}
            </a>
        );
    }

    return (
        <button onClick={handleClick} className={className}>
            <span>{children || email}</span>
        </button>
    );
};
